/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import { formValue } from "../../../services/formServiceFunctions";
import _ from "lodash";
import PensionInsurance from "./PensionInsurance/PensionInsurance";
import useForm from "../../../hooks/useForm";
import ValidatorForm from "../../Validator/ValidatorForm";
import SubmitButton from "../../Button/SubmitButton";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import { Box, SelectChangeEvent } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const PensionInsurances = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const empty = {
    name: "",
    policyHolder: "",
    date: "",
    value: "",
  };

  const initialValues = {
    hasPensionInsurance: pcs.hasPensionInsurance,
    pensionInsurances: !_.isEmpty(pcs.pensionInsurances) ? pcs.pensionInsurances : [empty],
  };

  const { values, handleChange, handleSubmit, touchedValues, errors, handleBlur } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  const add = () => {
    const pensionInsurances = values.pensionInsurances || [];
    if (pensionInsurances.length >= 3) {
      return;
    }

    pensionInsurances.push(empty);

    handleChange({
      target: {
        type: "other",
        name: "pensionInsurances",
        value: pensionInsurances,
      },
    });
  };

  const handleMore = ({ target }: SelectChangeEvent) => {
    const { name, value } = target;
    if (value === "yes") {
      add();
    }
    if (value === "no") {
      const splitName = _.split(name, "-");
      const lastPart = splitName[splitName.length - 1];
      const key = parseInt(lastPart);
      handleChange({
        target: {
          type: "other",
          name: "pensionInsurances",
          value: _.slice(values.pensionInsurances, 0, key + 1),
        },
      });
    }
  };

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Lebensversicherung</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Haben Sie eine Lebensversicherung oder private Rentenversicherung (z.B. Riester-Rente)?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorSelect
              label={"Lebensversicherung"}
              name={"hasPensionInsurance"}
              value={formValue(values, "hasPensionInsurance")}
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <MenuItem value={"no"}>Nein</MenuItem>
              <MenuItem value={"yes"}>Ja</MenuItem>
            </ValidatorSelect>
          </Grid>
          {formValue(values, "hasPensionInsurance") === "yes" && (
            <>
              {_.map(values.pensionInsurances, (pensionInsurance, key) => (
                <React.Fragment key={key}>
                  <PensionInsurance
                    path={`pensionInsurances[${key}]`}
                    pensionInsurance={pensionInsurance}
                    handleChange={handleChange}
                  />
                  {parseInt(key) < 2 && (
                    <>
                      <Grid sx={processCostSupportStyle.question} size={12}>
                        Haben Sie eine weitere Versicherung?
                      </Grid>
                      <Grid
                        size={{
                          xs: 12,
                          md: 6,
                          lg: 4
                        }}>
                        <ValidatorSelect
                          label={"Weitere Versicherung"}
                          name={`hasMore-${key}`}
                          value={formValue(values, "pensionInsurances").length - 1 > parseInt(key) ? "yes" : "no"}
                          onChange={handleMore}
                          onBlur={handleBlur}
                        >
                          <MenuItem value={"no"}>Nein</MenuItem>
                          <MenuItem value={"yes"}>Ja</MenuItem>
                        </ValidatorSelect>
                      </Grid>
                    </>
                  )}
                </React.Fragment>
              ))}
            </>
          )}
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default PensionInsurances;
